import Axios from 'axios';
// import {Client, Status} from "@googlemaps/google-maps-services-js";
// const client = new Client({});

// const googleMapsClient = require('@google/maps').createClient({
//     key: 'AIzaSyAxaSJvL0Jied07dirpHTqYRfSZy3wCRfw'
// });

export async function searchAddress(address) {
    const query = prepareQuery(address)
    try {
      let response = await axios.get('https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: query,
          key: 'AIzaSyAxaSJvL0Jied07dirpHTqYRfSZy3wCRfw'
        }
      });
      console.log(response);
      return response.data.results[0];
    } catch (e) {
      throw e;
    }

    // return new Promise((resolve, reject) => {
    //     client.geocode({
    //         params: {
    //           address: query,
    //           key: 'AIzaSyAxaSJvL0Jied07dirpHTqYRfSZy3wCRfw'
    //         }
    //     }, (err, response) => {
    //         console.log(response)
    //         if (!err) {
    //             resolve(response.json.results[0])
    //         }
    //
    //         reject(err)
    //     })
    // })

}


function prepareQuery(address) {
    const street = address.logradouro || '';
    const number = address.numero || '';
    const neighborhood = address.bairro || '';
    const city = address.cidade || '';
    const state = address.estado || '';
    const country = address.pais || '';

    return street
        + ', ' + number
        + ', ' + neighborhood
        + ', ' + city
        + ', ' + state
        + ', ' + country
}



// WEBPACK FOOTER //
// ./src/services/google_geocoding.js